import Vue from 'vue';
import App from './App.vue';
import store from './store';

import 'bootstrap';
import 'font-awesome/css/font-awesome.min.css';

import './assets/js/main';

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
